import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Divider } from '@mui/material';
import styles from './styles';
import InputField from '../common/InputField/InputField';
import { ResetPasswordProps } from './types';
import FormButton from '../common/FormButton';

const ResetPassword = ({
    handleSubmit,
    showError = false,
    handleInput,
    credentials,
    submitting,
}: ResetPasswordProps) => {
    return (
        <Box>
            <Typography id="reset_password_text1" data-testid="diathrive_title" sx={styles.subTitle} component="div">
                Create New{' '}
                <Typography id="reset_password_text2" sx={styles.title}>
                    Password
                </Typography>
            </Typography>
            <Typography id="reset_password_text3" sx={styles.description} component="div">
                Create a new password to access your account whose username is
                <Typography id="reset_password_text4" component="span" sx={styles.email}>
                    your.name@diathrive.com.
                </Typography>
                Password must have at least 8 characters, including one capital letter, one special character and one
                number and cannot be common.
            </Typography>
            <Divider sx={styles.divider} />
            <Box component="form" noValidate onSubmit={handleSubmit}>
                <InputField
                    required
                    name="password"
                    label="New Password"
                    type="password"
                    id="password"
                    placeholder="Type here..."
                    onChange={handleInput}
                    error={showError}
                    autoComplete="password"
                    value={credentials.password}
                />
                <Typography
                    component="div"
                    sx={{
                        mt: '24px',
                    }}
                >
                    <InputField
                        required
                        name="repeatPassword"
                        label="Repeat Password"
                        type="password"
                        id="repeatPassword"
                        placeholder="Type here..."
                        onChange={handleInput}
                        error={showError}
                        autoComplete="repeatPassword"
                        value={credentials.repeatPassword}
                    />
                </Typography>
                {showError ? (
                    <Typography id="forgot_password_error_text" sx={styles.error_message}>
                        Please check passwords, they do not match or meet password requirements.
                    </Typography>
                ) : null}

                <FormButton
                    id="confirm_password"
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={styles.confirmPass_Btn}
                    submitting={submitting}
                >
                    Confirm Password
                </FormButton>
            </Box>
        </Box>
    );
};

export default ResetPassword;
